import { render, staticRenderFns } from "./TaskSummaryWidget.vue?vue&type=template&id=68c40b06&scoped=true"
import script from "./TaskSummaryWidget.vue?vue&type=script&lang=js"
export * from "./TaskSummaryWidget.vue?vue&type=script&lang=js"
import style0 from "./TaskSummaryWidget.vue?vue&type=style&index=0&id=68c40b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c40b06",
  null
  
)

export default component.exports